import { render, staticRenderFns } from "./infoMessageBox.vue?vue&type=template&id=6a31ec0c"
import script from "./infoMessageBox.vue?vue&type=script&lang=js"
export * from "./infoMessageBox.vue?vue&type=script&lang=js"
import style0 from "./infoMessageBox.vue?vue&type=style&index=0&id=6a31ec0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports